const base = 'neopvc';

export const GetterTypes = {
  GET_PROJECTS: `${base}/GET_PROJECTS`,
  GET_AUDIT_ENTRIES: `${base}/GET_AUDIT_ENTRIES`,
  GET_CURRENT_TAB: `${base}/GET_CURRENT_TAB`,
  GET_NEW_PROJECT: `${base}/GET_NEW_PROJECT`,
};

export const ActionTypes = {
  FETCH_PROJECTS: `${base}/FETCH_PROJECTS`,
  FETCH_AUDIT_ENTRIES: `${base}/FETCH_AUDIT_ENTRIES`,
  UPDATE_CURRENT_TAB: `${base}/UPDATE_CURRENT_TAB`,
  UPDATE_NEW_PROJECT: `${base}/UPDATE_NEW_PROJECT`,
  SAVE_NEW_PROJECT: `${base}/SAVE_NEW_PROJECT`,
  CALCULATE_PROJECT_DESTINY: `${base}/CALCULATE_PROJECT/DESTINY`,
  CALCULATE_PROJECT_ORIGIN: `${base}/CALCULATE_PROJECT/ORIGIN`,
};

export const MutationTypes = {
  SET_PROJECTS: `${base}/SET_PROJECTS`,
  SET_AUDIT_ENTRIES: `${base}/SET_AUDIT_ENTRIES`,
  SET_CURRENT_TAB: `${base}/SET_CURRENT_TAB`,
  SET_NEW_PROJECT: `${base}/SET_NEW_PROJECT`,
};
